import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import App from "./App";
import MarkAttendance from "./markattendence";

const AppRouter = () => {
  return (
    <Routes>
      <Route exact path="/" element={<App />} />
      {/* <Route path="/:id" element={<MarkAttendance />} /> */}
    </Routes>
  );
};

export default AppRouter;
